module.exports = __webpack_public_path__ + "media/images/new-ui-images/list-blue-310ab5c98a0c4b5a4ccbcb2d421970a0.svg";